import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Utils from '../../../custom/utils';
import {API} from "../../../../config";
import _ from "lodash";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {connect} from "react-redux";
import FormControl from '@material-ui/core/FormControl';

const investorInbound = API.service('inbound-transfers');
const wallet = API.service('wallet');

const moment = require('moment');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        //border:'2px solid ' + theme.navigation.selected.backgroundColor,
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    },
    debutton:{
        padding:'5px 12px',
        //background:theme.navigation.selected.backgroundColor,
        //color:theme.navigation.selected.contrast,
        borderRadius:3,
        boxShadow:'2px 2px 2px #eee',

        '&:hover':{
            //background:theme.navigation.hover.backgroundColor,
            //color:theme.navigation.selected.contrast,
        }
    }
});

class InboundDepositRow extends Component {
    state={
        amount_received: this.props.row._amount_expected,
        fee: this.props.row._fees_paid,
        _timestamp:null,
    };

    complete = () => {
        const app = this;
        let payload = [
            {
                _account:this.props.row.investors[0]._account,
                _fund: parseFloat(this.state.amount_received),
                _comment:'Wire Transfer',
                _type: 'CREDIT-WIRE_TRANSFER',
                _reference_id:this.props.row._id,
                _currency: this.props.row._currency
            },
            {
                _account:this.props.row.investors[0]._account,
                _fund: 0 - parseFloat(this.state.fee),
                _comment:'Fee for Wire Transfer',
                _type: 'DEBIT-FEE',
                _reference_id:this.props.row._id,
                _currency: this.props.row._currency
            },
        ]

        wallet.create(payload).then(w=>{
            investorInbound.patch(app.props.row._id,{
                _status:parseInt(app.props.row._status,10) + 256,
                _amount_received:parseFloat(app.state.amount_received),
                _fees_paid:parseFloat(app.state.fee),
                _net_received:parseFloat(app.state.amount_received)
            }, {query:{$limit:1, _id: app.props.row._id}}).then(o=>{
                app.props.context.update({
                    popupContent: false,
                })
            });
        });
    };


    //TODO: Add popup Confirmation for Cancellation
    cancel = () => {
        const app = this;
        investorInbound.patch(app.props.row._id,{
            _status:parseInt(app.props.row._status,10) + 128,
        }, {query:{$limit:1, _id: app.props.row._id}}).then(o=>{
            app.props.context.update({
                popupContent: false,
            })
        });
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state, error: '' }, event.target.id, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    };

    close = () =>{
        this.props.context.update({
            popupContent: false,
        })
    };

    render() {
        const {classes} = this.props;
        let currency = Utils.getCurrency(this.props.row._currency.toUpperCase());

        let amnt = this.props.row._amount_expected || this.props.row._amount;

        return (
            <React.Fragment>
                <h3>Complete Deposit</h3>
                <b>Investor:</b> {this.props.row.investors[0]._firstname} {this.props.row.investors[0]._surname}<br />
                <b>Account:</b> {this.props.row.investors[0]._account}<br /><br />
                <b>Amount Expected:</b> {currency.currency_symbol}{Utils.addThousandCommas(amnt, '0,0.00')}
                <br /><br />
                <FormControl className={classes.formControl}>
                    <TextField
                      id="_timestamp"
                      name="_timestamp"
                      label="Deposit Date & Time"
                      type="datetime-local"
                      className={classes.textField}
                      value={this.state._timestamp}
                      onChange={this.handleChange}
                      margin="normal"
                      defaultValue={moment().format('YYYY-MM-DDTHH:MM')}
                    />
                </FormControl>
                <br />
                <TextField
                  id="amount_received"
                  label="Amount Received"
                  className={classes.textField}
                  value={this.state.amount_received}
                  onChange={this.handleChange}
                  margin="normal"
                />
                <br />
                <TextField
                  id="fee"
                  label="Less Fee of"
                  className={classes.textField}
                  value={this.state.fee}
                  onChange={this.handleChange}
                  margin="normal"
                />
                <br />
                {(Utils.isEmpty(this.props.user.affiliate)) &&
                    <Button variant="contained" color="secondary" onClick={this.complete}>
                        Complete
                    </Button>
                }
                &nbsp;
                <Button variant="contained" color="primary" onClick={this.cancel}>
                    Cancel Deposit
                </Button>
                &nbsp;
                <Button variant="outlined" color="secondary" onClick={this.close}>
                    Close
                </Button>
            </React.Fragment>
        )
    }
}
function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(InboundDepositRow))));
